document.addEventListener('click', (event) => {
  const rating = event.target.closest('.gal-and-goose-product-rating');

  if (!rating) return;

  const reviews = document.querySelector('#judgeme-product-reviews');

  if (!reviews) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  reviews.open = true;

  window.requestAnimationFrame(() => {
    reviews.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
}, true);
